/**
 * Module dependencies.
 */

import { GetStaticProps, NextPage } from 'next/types';
import { Market } from 'src/types/markets';
import { PageFields } from 'src/types/page-fields';
import { fetchMarkets } from 'src/api/markets/fetch-markets';
import { fetchPageFields } from 'src/api/page-fields/fetch-page-fields';
import { media, units } from '@untile/react-components';
import MarketsList from 'src/components/pages/markets';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  data: PageFields;
  markets: Market[];
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.section`
  padding: ${units(14)} 0 ${units(9)};

  ${media.min('md')`
    padding: ${units(20)} 0 ${units(18)};
  `}
`;

/**
 * `MarketsPage` page.
 */

const MarketsPage: NextPage<Props> = props => (
  <Wrapper>
    <MarketsList {...props} />
  </Wrapper>
);

/**
 * Export `getStaticProps`.
 */

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
  const data = await fetchPageFields({ locale });
  const markets = await fetchMarkets({ locale });

  if (!data || !markets) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data,
      markets
    },
    revalidate: 60
  };
};

/**
 * Export `MarketsPage` page.
 */

export default MarketsPage;
